const EducationInfo = [
    {
        Months: '2025- present',
        CompanyName:
            'Brandenburgische Technische Universität Cottbus-Senftenberg',
        Role: 'Master of Science in AI',
        CompanyLogo:
            'https://www.b-tu.de/typo3conf/ext/btu_template/Resources/Public/Images/logo/BTULogo_notext_grau.png',
        Description:
            'I am pursuing a Master’s in Artificial Intelligence at BTU, focusing on machine learning, robotics, and real-time AI systems. My coursework and projects emphasize practical problem-solving, interdisciplinary research, and innovation in intelligent technologies.',
        TechIcon: [],
        CompanyLink: 'https://www.b-tu.de/',
        Place: 'Cottbus, Germany',
    },
    {
        Months: '2021-2024',
        CompanyName: 'Shivaji University, Kolhapur',
        Role: 'Bachelor of Technology in CSE(AI-ML)',
        CompanyLogo:
            'https://www.pngkey.com/png/detail/269-2691243_shivaji-university-kolhapur-logo.png',
        Description:
            'Completed my bachelor’s with strong foundations in AI, data science, and software development. I worked on multiple real-world projects involving deep learning, NLP, and computer vision, and secured 2nd place in a coding competition organized by the college coding club.',
        TechIcon: [],
        CompanyLink: 'https://shivajiuniversity.org/',
        Place: 'Kolhapur, India',
    },
]

export default EducationInfo
